export default o => JSON.parse(JSON.stringify(o))
